import { React, useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate, useLocation, Navigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useSnackbar } from 'notistack';

// material
import {
    Card,
    IconButton,
    Stack,
    Button,
    TextField,
    Divider,
    FormControl,
    MenuItem,
    InputLabel, Select,
    Autocomplete,
    Tooltip,
} from '@mui/material';
import { Icon } from '@iconify/react';
import Moment from 'moment';
import Iconify from '../../Iconify';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import URLS from '../../../services/urls.service';
import Page from '../../Page';
import AppCache from '../../../services/AppCache';


// ----------------------------------------------------------------------



// ----------------------------------------------------------------------

export default function ClientInstallation() {

    const TABLE_HEAD = [
        { field: 'ClientName', headerName: 'Client Name', flex: 1 },
        { field: 'SiteName', headerName: 'Site Name', flex: 1 },
        { field: 'ProjectVersionName', headerName: 'Project Version Name', flex: 1 },
        {
            field: 'StartDate', headerName: 'Start Date', width: 150, valueFormatter: params =>
                Moment(params?.value).format("DD-MMM-yyyy")
        },
        {
            field: 'EndDate', headerName: 'End Date', width: 150, valueFormatter: params =>
                Moment(params?.value).format("DD-MMM-yyyy")
        },
        {
            field: 'actions',
            headerName: '',
            type: 'actions',
            width: 20,
            justifyContent: 'end',
            renderCell: (cellValues) => (
                <div>
                    <IconButton
                        onClick={(event) => {
                            handleClick(event, cellValues);
                        }}><Iconify icon="material-symbols:border-color-outline" width='16px' height='16px' color='#155DFC' /></IconButton>

                </div>
            )
        },
        {
            field: 'view',
            headerName: '',
            type: 'actions',
            width: 2,
            renderCell: (cellValues) => (
                <div>
                    <IconButton
                        onClick={(event) => {
                            handleViewClick(event, cellValues);
                        }}><Iconify icon="material-symbols:visibility-outline" width='16px' height='16px' color='primary.main' /></IconButton>

                </div>
            )
        },
    ];

    // dropdown
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const [siteData, setSiteData] = useState([]);
    const [isLoading, setIsLoading] = useState();

    const location = useLocation();

    const [client, setClient] = useState("");
    const [selectedClient, setSelectedClient] = useState([]);
    const [site, setSite] = useState("");
    const [selectedSite, setSelectedSite] = useState([]);
    const [project, setProject] = useState('');
    const [selectedProject, setSelectedProject] = useState([]);
    const [editData, setEditData] = useState([]);
    const [pageSize, setPageSize] = useState(25);

    const handleClient = (newValue) => {
        const clientId = newValue?.ClientId || 0;
        setClient(clientId);
    }
    const handleSite = (newValue) => {
        const siteId = newValue?.SiteId || 0;
        setSite(siteId);
    }
    const handleProject = (newValue) => {
        setProject(newValue?.ProjectVersionId || "");
    };
    const onFilterClick = () => {

        const payload = {
            "SiteFilterID": site,
            "ClientFilterID": client,
            "ProjectFilterID": project
        }
        URLS.getClientInstallationFilterDropDown(payload)
            .then((response) => {
                setSiteData(response.data);
                setIsLoading(false);
                enqueueSnackbar("Fetched Data Successfully.", { variant: 'success' });
            })
            .catch(error => {
                setIsLoading(false);
                enqueueSnackbar("Record Not Found.", { variant: 'error' });

                console.log("error", error)
            });

    };

    const handleClick = (event, cellValues) => {
        setIsLoading(true);

        console.log("cellValues", cellValues)
        const payload = {
            "ContactId": cellValues?.row.ContactId || 0,
            "SiteId": cellValues?.row.SiteId || 0,
        }
        URLS.editLoadClientInstallationLocations(payload)
            .then((response) => {
                setEditData(response.data);
                setIsLoading(false);
                navigate('/dashboard/clientinstallationdetailspage', { state: { mode: "edit", clientInstallationData: response.data } })

            })
            .catch(error => {
                setIsLoading(false);
                enqueueSnackbar("Record Not Found.", { variant: 'error' });
            });
    }

    const handleViewClick = (event, cellValues) => {
        setIsLoading(true);

        console.log("cellValues", cellValues)
        const payload = {
            "ContactId": cellValues?.row.ContactId || 0,
            "SiteId": cellValues?.row.SiteId || 0,
        }
        URLS.editLoadClientInstallationLocations(payload)
            .then((response) => {
                setEditData(response.data);
                setIsLoading(false);
                navigate('/dashboard/clientinstallationdetailspage', { state: { mode: "view", clientInstallationData: response.data } })

            })
            .catch(error => {
                setIsLoading(false);
                enqueueSnackbar("Record Not Found.", { variant: 'error' });
            });
    }
    
    const handleReset = () => {
        setClient("");
        setSite("");
        setProject("");
        setSiteData([]);
    }
    useEffect(() => {
        URLS.getServiceEntryClientName()
            .then((response) => {
                setSelectedClient(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getServiceEntrySiteName({ ClientId: "0" })
            .then((response) => {
                setSelectedSite(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        // URLS.projectList()
        URLS.getServiceEntryProject()

            .then((response) => {
                setSelectedProject(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
    }, []);

    useEffect(() => {
        setClient("");
        setSite("");
        setProject("");
        setSiteData('')

    }, [location.key]);

    return (

        <Page title="Client Installation Locations" >

            <Stack direction="row" alignItems="center" justifyContent="space-between" mt={1} spacing={1}>
                <FormControl size="small" fullWidth>

                    <Autocomplete
                        fullWidth
                        size="small"
                        id="client"
                        value={selectedClient.find((item) => item.ClientId === client) || null}
                        onChange={(_, newValue) => handleClient(newValue)}
                        options={selectedClient}
                        getOptionLabel={(option) => option.Name || ""}
                        isOptionEqualToValue={(option, value) => option.ClientId === value.ClientId}
                        renderOption={(props, option) => (
                            <li {...props} key={option.ClientId}>
                                {option.Name}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Select Client"
                                variant="outlined"
                                label="Client"
                            />
                        )}

                    />
                </FormControl>

                <FormControl size="small" fullWidth>
                    <Autocomplete
                        fullWidth
                        size="small"
                        id="project Version"
                        value={selectedProject.find((item) => item.ProjectVersionId === project) || null}
                        onChange={(_, newValue) => handleProject(newValue)}
                        options={selectedProject}
                        getOptionLabel={(option) => option.ProjectVersionName || ""}
                        isOptionEqualToValue={(option, value) => option.ProjectVersionId === value.ProjectVersionId}
                        renderOption={(props, option) => (
                            <li {...props} key={option.ProjectVersionId}>
                                {option.ProjectVersionName}
                            </li>
                        )}

                        renderInput={(params) => <TextField {...params} placeholder="Enter Project" label="Project Version" />}
                    />
                </FormControl>
                <FormControl size="small" fullWidth>

                    <Autocomplete

                        fullWidth
                        size="small"
                        id="site"
                        value={selectedSite.find((item) => item.SiteId === site) || null}
                        onChange={(_, newValue) => handleSite(newValue)}
                        options={selectedSite}
                        getOptionLabel={(option) => option.Name || ""}
                        isOptionEqualToValue={(option, value) => option.SiteId === value.SiteId}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Select Site"
                                variant="outlined"
                                label="Site"

                            />
                        )}

                        renderOption={(props, option) => (
                            <li {...props} key={option.SiteId}>
                                {option.Name}
                            </li>
                        )}
                    />
                </FormControl>

                <Stack direction={{ xs: "column", sm: "row" }} alignItems="center" justifyContent="space-between" spacing={1}>

                    <Tooltip title="Filter">

                        <Button
                            variant="contained"
                            size="small"

                            onClick={onFilterClick}
                        ><Icon icon="ic:outline-filter-alt" width="25px" height="25px" /></Button>
                    </Tooltip >
                    <Tooltip title="Reset">

                        <Button
                            variant="outlined" color="inherit"
                            size="small"
                            onClick={handleReset}
                        ><Icon icon="ic:twotone-restart-alt" width="25px" height="25px" /></Button>

                    </Tooltip >
                    <Tooltip title="Add New">

                        <Button
                            component={RouterLink}
                            to='/dashboard/clientinstallationdetailspage'
                            variant="contained"
                            size="small"
                            state={{ mode: "add", clientInstallationData: { SiteId: '', ContactId: '', Name: '', ERPCode: '', ContactTypeId: '', Remarks: '', IsSite: '', ClientId: '', ProjectVersionId: '', StartDate: new Date(), EndDate: new Date(), AMCType: '', NoOfLicences: '', WebSite: '', Address: '', Country: '', State: '', City: '', District: '', PinCode: '', Region: '', Classification: '', FirstContactBy: '', ExecutiveID: '', contactmaster: { SiteId: '', ContactId: '', Location: '', ContactPersonName: '', ContactNo: '', Mobile: '', Email: '' } } }}
                        ><Icon icon="ic:baseline-plus" width="25px" height="25px" /></Button>

                    </Tooltip >



                </Stack>

            </Stack>

            {/* ----------------------------------------------------------------- */}

            <div style={{ height: '73vh', width: '100%' }}>
               
                <DataGrid
                    rows={siteData}
                    columns={TABLE_HEAD}
                    density="compact"
                    getRowId={(row) => row.id || siteData.indexOf(row)}
                    components={{ Toolbar: GridToolbar }}
                    pagination
                    paginationMode="client"
                    rowsPerPageOptions={[25, 50, 100]}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                />
            </div>

            {isLoading && (<LoadingProgressBar sx={{ py: 9 }} />)}
        </Page>


    );
}